const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

export interface TransferResult {
  message: string;
  transfer: {
    customerId: string;
    customerName: string;
    fromUserId: string;
    toUserId: string;
    toUserName: string;
    updatedRecords: {
      projects: number;
      documents: number;
      chatSessions: number;
      comparisonReports: number;
      underwritingReports: number;
      workflows: number;
      workflowJobs: number;
      savedWorkflows: number;
      sharesRemoved: number;
      previousOwnerShareCreated: boolean;
    };
  };
}

class TransferService {
  private getAuthHeaders() {
    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('riskninja-token')}`
    };
  }

  async transferCustomer(
    customerId: string,
    toUserId: string,
    keepShareForPreviousOwner: boolean = true
  ): Promise<TransferResult> {
    const response = await fetch(`${API_BASE_URL}/api/customers/${customerId}/transfer`, {
      method: 'POST',
      headers: this.getAuthHeaders(),
      body: JSON.stringify({ toUserId, keepShareForPreviousOwner })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Failed to transfer customer' }));
      throw new Error(errorData.error || 'Failed to transfer customer');
    }

    return await response.json();
  }
}

export const transferService = new TransferService();
